import { getScreens } from './getScreens';
import { getScreensMeta } from './getScreensMeta';
import { getScreensFilterOptions } from './getScreensFilterOptions/getScreensFilterOptions';
import { getProxyComponents } from './getProxyComponents';
import { getScreenComponent } from './getScreenComponent';

export const screensService = {
  get: getScreens,
  getMeta: getScreensMeta,
  getFilterOptions: getScreensFilterOptions,
  getProxyComponents: getProxyComponents,
  getComponent: getScreenComponent,
};
